// Per-clone dev ports come from apps/website/.env (VITE_PORT for the vite
// dev server, VITE_SERVER_PORT for the Express server it talks to). Tracked
// files read those vars so a new clone never has to edit them here.
const DEV_VITE_PORT = import.meta.env.VITE_PORT ?? '5173'
const DEV_SERVER_PORT = import.meta.env.VITE_SERVER_PORT ?? '4000'

const DEV_ENVIRONMENT = {
  STRIPE_PUBLIC_KEY:
    'pk_test_51RP5ijPVBR15uDc31T4y4tV7ohuAPpn1TQFZuXfvvM3HxugIM8tEEsKDPQDzk3jC2dW7Gg5APkWlveP30rfdTwKQ00Qpu6VKtP',
  WEBSITE_URL: `https://localhost:${DEV_VITE_PORT}`,
  SERVER_URL: `https://localhost:${DEV_SERVER_PORT}`,
  SENTRY_DSN:
    'https://bb8bd66a49269fed7e63188180ee9fb1@o4507561829793792.ingest.us.sentry.io/4507561833136128',
  GOOGLE_MAPS: 'AIzaSyDoH7uHmTOFZgT72FQSufRHj2JcLladvrc',
}

const PROD_ENVIRONMENT = {
  STRIPE_PUBLIC_KEY:
    'pk_live_51RP5ieBQHFzoFkt84BtwfPhfdyhF4iURkKMg0f2mHWyUKaDgMoLiEkwrj5GIxozyAr3IdmhkqSTcm5rSwu3e6Dz3008JJtzhs5',
  WEBSITE_URL: 'https://signup.software',
  SERVER_URL: 'https://api.signup.software',
  SENTRY_DSN:
    'https://bb8bd66a49269fed7e63188180ee9fb1@o4507561829793792.ingest.us.sentry.io/4507561833136128',
  GOOGLE_MAPS: 'AIzaSyDoH7uHmTOFZgT72FQSufRHj2JcLladvrc',
}

export const ENVIRONMENT = import.meta.env.DEV
  ? DEV_ENVIRONMENT
  : PROD_ENVIRONMENT
